import { Stack, Typography } from "@mui/material";
import { Contract, Establihsment } from "../consts/types";
import { t } from "i18next";
import { TFunction } from "i18next";

const UploadErrorDataList = ({
    data,
    establishments,
    contracts,
    translate
}: {
    data: Partial<Record<string, string[]>>;
    establishments: Establihsment[];
    contracts?: Contract[];
    translate: TFunction;
}) => {
    return (
        <Stack spacing={1}>
            {Object.entries(data).flatMap(([cuit, values]) => {
                const displayName =
                    contracts?.find((contract) => contract.cuit === cuit)?.nombre || cuit;

                return values?.map((value, index) => (
                    <Typography key={`${cuit}-${index}`} variant="body1">
                        {`- ${translate('header.errorsInfo.establishment')}: ${value} -  ${
                            establishments?.find((establishment) => establishment?.numero === value)
                                ?.nombre || '-'
                        }, Contrato ${cuit} (${displayName})`}
                    </Typography>
                ));
            })}
        </Stack>
    );
};

export default UploadErrorDataList;
